/**
 * Crops `src` to a fractional rectangle ({x, y, w, h} in 0..1) and returns an
 * object URL for the cropped PNG. Used to turn the whole-piece outline into this
 * player's sub-slice so the normal drawing canvas can be used unchanged.
 *
 * `src` should be same-origin (a blob: URL from fetchAssetAsObjectUrl) or the
 * canvas is tainted and export fails; in that case the ORIGINAL src is returned
 * so the page still loads (the caller logs the degraded case).
 */
export function cropImageToRect(src, rect) {
  return new Promise((resolve) => {
    if (!src || !rect) {
      resolve(src);
      return;
    }
    const img = new Image();
    if (!String(src).startsWith('blob:')) img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const sx = Math.round(rect.x * img.naturalWidth);
        const sy = Math.round(rect.y * img.naturalHeight);
        const sw = Math.max(1, Math.round(rect.w * img.naturalWidth));
        const sh = Math.max(1, Math.round(rect.h * img.naturalHeight));
        const out = document.createElement('canvas');
        out.width = sw;
        out.height = sh;
        out.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
        out.toBlob((blob) => {
          if (!blob) {
            console.warn('cropImageToRect: export failed; using the whole piece');
            resolve(src);
            return;
          }
          resolve(URL.createObjectURL(blob));
        }, 'image/png');
      } catch (err) {
        console.warn('cropImageToRect: could not crop (tainted canvas?); using the whole piece', err);
        resolve(src);
      }
    };
    img.onerror = () => resolve(src);
    img.src = src;
  });
}
